import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AnimationEvent } from '@angular/animations';
import { Subscription } from 'rxjs';
import { slideOut } from 'src/app/shared/animations/slide';
import { PageEnums } from 'src/app/shared/enum/page-enums';
import { DetailPageInfo } from 'src/app/shared/model/deail-page-info.model';
import { MailInfo } from 'src/app/shared/model/mail-info.model';
import { MailRejectReasons } from 'src/app/shared/model/mail-reject-reasons';
import { MatchingOffer } from 'src/app/shared/model/matching-offer.model';
import { PageInfo } from 'src/app/shared/model/page-info.model';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { AccountService } from 'src/app/shared/service/account.service';
import { OfferService } from 'src/app/shared/service/offer.service';
import { PairSuitabilityFeedbackService } from 'src/app/shared/service/pair-suitability-feedback.service';
import { SearchProjectWorkerService } from 'src/app/shared/service/search/search-project-worker.service';
import { SearchConditionService } from 'src/app/shared/service/search-condition.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-matching-project-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
  animations: [slideOut('right')]
})
export class MatchingProjectDetailComponent implements OnInit, OnDestroy {
  showRecommend = true;
  showSearch = true;
  closeSearch = false;
  selectedText = '';
  pageInfo: PageInfo;
  projectId: string;
  project: MailInfo;
  workers: Array<MailInfo> = [];
  calc_workers: Array<MailInfo> = [];
  mailRejectReasons: MailRejectReasons;
  sharedAccountOffers: MatchingOffer[]; // 共通アカウント（USER_CODE）に紐付くオファーを取得
  offeredProjectMailIds: number[]; // offersの中のproject_mail_id
  offeredWorkerMailIds: number[]; // offersの中のworker_mail_id
  alreadyRead = true;
  focusCardId = -1;
  openCardIds: number[] = [];
  @Input() matchingOffer: MatchingOffer;
  ActionLogForDetailId: number;
  searchParams: SearchCondition;
  loading = false;
  baseMailLoad = false;
  routeParams: string;
  detailPageInfo: DetailPageInfo = new DetailPageInfo({});
  autoLoadCount = 0;
  page = PageEnums.project_detail;

  // subscriptions
  stateSub$: Subscription;
  nextPageLoad$: Subscription;
  showSub$: Subscription;
  routeState$: Subscription;
  offerSub$: Subscription;
  submittedPair$: Subscription;
  disLikedPair: string[][] = [];
  private workerRuleSubscription: Subscription;
  private sharedOffersSubscription: Subscription;

  constructor(
    private pairSuitabilityFeedbackService: PairSuitabilityFeedbackService,
    private router: Router,
    private route: ActivatedRoute,
    public accountService: AccountService,
    public searchProjectWorkerService: SearchProjectWorkerService,
    private activeRoute: ActivatedRoute,
    private searchConditionService: SearchConditionService,
    private offerService: OfferService,
    private toastrService: ToastrService,

  ) {
    this.projectId = route.snapshot.params['id'];
  }

  ngOnInit() {
    this.getDisplayOptions();
    this.routeParams = this.projectId;
    // ベースメールが変わった時
    // TODO: URLが変わるから、この処理はそもそも不要なのでは？
    this.routeState$ = this.activeRoute.params.subscribe(routeParams => {
      if (this.routeParams !== routeParams.id) {
        if (this.nextPageLoad$) {
          this.nextPageLoad$.unsubscribe();
        }
        if (this.showSub$) {
          this.showSub$.unsubscribe();
        }
        this.projectId = routeParams.id;
        this.routeParams = routeParams.id;
        this.alreadyRead = false;
        this.loading = false;
        this.pageLoad();
      }
    });

    // イベント受信時の処理
    this.stateSub$ = this.searchProjectWorkerService.searchState.subscribe(
      res => {
        if (this.nextPageLoad$) {
          this.nextPageLoad$.unsubscribe();
        }
        if (this.showSub$) {
          this.showSub$.unsubscribe();
        }
        this.getAdditionalMailInfo();
        // TODO: projectを更新する必要があるか要確認（pageLoad()での読み込みだけで十分に見える）
        this.project = res.project;
        this.workers = [];
        this.autoLoadCount = 0;
        this.calc_workers = res.workers;
        this.mailRejectReasons = new MailRejectReasons(res.reasons);
        this.ActionLogForDetailId = res.ActionLogForDetailId;
        this.detailPageInfo = new DetailPageInfo(res);
        this.alreadyRead = true;
        this.loading = false;
        this.onScroll();
      }
    );

    // 初回読み込み処理
    this.pageLoad();

    this.submittedPair$ = this.pairSuitabilityFeedbackService.submittedPair$
      .asObservable()
      .subscribe(param => {
        if (!param.suitable) {
          this.disLikedPair.push([param.ai_worker_id, param.ai_project_id]);
        }
      });
  }

  ngOnDestroy() {
    if (this.workerRuleSubscription) {
      this.workerRuleSubscription.unsubscribe();
    }
    if (this.sharedOffersSubscription) {
      this.sharedOffersSubscription.unsubscribe();
    }
    if (this.submittedPair$) {
      this.submittedPair$.unsubscribe();
    }
    if (this.stateSub$) {
      this.stateSub$.unsubscribe();
    }
    if (this.nextPageLoad$) {
      this.nextPageLoad$.unsubscribe();
    }
    if (this.showSub$) {
      this.showSub$.unsubscribe();
    }
    if (this.routeState$) {
      this.routeState$.unsubscribe();
    }
    if (this.offerSub$) {
      this.offerSub$.unsubscribe();
    }
  }

  pageLoad(): void {
    if (this.showSub$) {
      this.showSub$.unsubscribe();
    }
    // デフォルト検索項目取得し、sessionにセット
    this.workerRuleSubscription = this.searchConditionService.getWorkerRule().subscribe(res => {
      this.searchParams = new SearchCondition(res.body.default_search_rule);
      // 基準メールの読み込み
      this.showSub$ = this.searchProjectWorkerService
        .showProjectMail(this.projectId)
        .subscribe(
          showRes => {
            this.project = showRes.body ? showRes.body.project : new MailInfo({});
            this.baseMailLoad = true;
            this.searchParams = this.searchConditionService.overRideBaseMailCondition(
              this.searchParams,
              this.project
            );
            this.searchProjectWorkerService.setSearchCondition(
              this.searchParams
            );
            this.detailPageInfo = new DetailPageInfo({});
            this.loading = true;
            this.searchProjectWorkerService.search$.next({
              id: this.projectId,
              additionalParams: this.detailPageInfo
            });
          },
          error => {
            if (error.status === 404) {
              this.toastrService.error(
                '指定されたメールが見つかりませんでした'
              );
            } else {
              this.toastrService.error(
                'エラーが発生しました。お手数ですが、再度お試しください'
              );
            }
            this.router.navigate(['/matching/projects']);
          }
        );
    });
  }

  getAdditionalMailInfo(): void {
    // 共通アカウント（USER_CODE）に紐付くオファーを取得
    // TODO: list処理で既に取得しているので、ここで取得する必要はなさそう
    this.sharedOffersSubscription = this.offerService.getSharedOffers().subscribe(res => {
      this.sharedAccountOffers = res.body.offers;
      this.offeredProjectMailIds = this.sharedAccountOffers.map(offer => offer.project_mail_id);
      this.offeredWorkerMailIds = this.sharedAccountOffers.map(offer => offer.worker_mail_id);
    });
  }

  openCard(i: number): boolean {
    return this.openCardIds.includes(i);
  }
  clickCard(i) {
    if (this.openCardIds.includes(i)) {
      this.openCardIds = this.openCardIds.filter(id => id !== i);
      this.focusCardId = -1;
    } else {
      this.focusCardId = i;
      this.openCardIds.push(i);
    }
  }

  loadingStart() {
    this.alreadyRead = false;
  }

  loadingFinish() {
    this.alreadyRead = true;
  }

  updateClickOpenLog(worker, i) {
    // クリック判定の前に呼ばれるため、!がつく
    const params = { mail_info: worker, mail_type: 'worker' };
    if (!this.openCard(i)) {
      this.searchProjectWorkerService
        .updateActionLogClickOpenDetail(params)
        .subscribe(res => {});
    }
    this.focusCardId = i;
  }

  preventClickEvent(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }

  // ページ移動
  transitePage(direction: string): void {
    this.searchProjectWorkerService.transitionPage(this.projectId, direction);
    this.focusCardId = -1;
  }

  onDeletedProject() {
    this.router.navigate(['/matching/projects']);
  }

  onDeletedWorker(i) {
    if (i < this.calc_workers.length) {
      this.calc_workers.splice(i, 1);
    } else {
      this.workers.splice(i - this.calc_workers.length, 1);
    }
  }

  // メール数が10件以下、且つ、ページに存在する時だけ、メール取得処理の作成
  // ページから移動した時に処理を終了するため
  autoLoad(): void {
    if (this.router.url.indexOf('project') !== -1) {
      if (this.workers.length < 10 && this.autoLoadCount < 10) {
        this.autoLoadCount += 1;
        this.onScroll();
      }
    }
  }

  // APIからinfiniteScrollEndの値が返ってきた場合は、処理を停止
  onScroll() {
    if (!this.detailPageInfo.infiniteScrollEnd) {
      this.loading = true;
      this.nextPageLoad$ = this.searchProjectWorkerService
        .search(this.projectId, this.detailPageInfo)
        .subscribe(res => {
          this.workers = this.workers.concat(res.body.workers);
          this.loading = false;
          if (res.body) {
            this.detailPageInfo = new DetailPageInfo(res.body);
            this.autoLoad();
          }
        });
    }
  }
  getKeysForBaseMail() {
    let keyWordsObject = null;
    if (this.openCardIds.includes(this.focusCardId)) {
      const mail =
        this.calc_workers[this.focusCardId] ||
        this.workers[this.focusCardId - this.calc_workers.length];
      if (mail) {
        keyWordsObject = mail.keywords;
      }
    }
    return this.getKeys(keyWordsObject);
  }
  getKeys(keyWordsObject: object): Array<string> {
    const baseKeywords = [];
    if (keyWordsObject) {
      for (const [key, value] of Object.entries(keyWordsObject)) {
        if (value > 1) {
          baseKeywords.push(key);
        }
      }
    }
    return baseKeywords;
    // return keyWordsObject ? Object.keys(keyWordsObject) : [];
  }
  IsDislikePair(worker_id: string, project_id: string): string {
    const findPair = this.disLikedPair.find(
      pair => pair[0] === worker_id && pair[1] === project_id
    );
    return !!findPair ? 'true' : 'false';
  }
  dislikeDoneEvent(
    worker_id: string,
    project_id: string,
    event: AnimationEvent
  ) {
    if (event.fromState === 'false' && event.toState === 'true') {
      this.focusCardId = -1;
      this.workers = this.workers.filter(mail => mail.ai_mail_id !== worker_id);
      this.disLikedPair = this.disLikedPair.filter(
        pair => pair[0] !== worker_id || pair[1] !== project_id
      );
    }
  }

  availableLength(mails: MailInfo[]): boolean {
    return mails.filter(m => !m.is_pair_already_offered).length > 0;
  }
  getDisplayOptions() {
    const detailColumnDisplayOptions = this.accountService.getDetailColumnDisplayOptions();
    this.showRecommend = detailColumnDisplayOptions.project_recommend;
    this.showSearch = detailColumnDisplayOptions.project_search;
  }

  changeDisplayOptions(option: 'recommend' | 'search'): void {
    switch (option) {
      case 'recommend':
        this.accountService.setDetailColumnDisplayOptions({
          project_recommend: this.showRecommend
        });
        break;

      case 'search':
        this.accountService.setDetailColumnDisplayOptions({
          project_search: this.showSearch
        });
        break;
    }
  }
}
